import * as React from 'react';
import { ArticleParagraph1 } from '@cian/ui-kit';

import { InlineButton } from '../InlineButton';
import { NBSP } from '../../../../constants/symbols';

export interface ICountDownProps {
  seconds: number;

  onClick(): void;
}

export const CountDown: React.FC<React.PropsWithChildren<ICountDownProps>> = ({ seconds, onClick }) => {
  const text = `Получить код ещё${NBSP}раз`;

  return (
    <div>
      {seconds > 0 ? (
        <ArticleParagraph1 color="text-primary-disabled">
          {text} через {seconds} сек.
        </ArticleParagraph1>
      ) : (
        <InlineButton onClick={onClick}>{text}</InlineButton>
      )}
    </div>
  );
};

CountDown.displayName = 'CountDown';
